/**
 * Created by Ning Jiang on 2021-05-27.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData, ReelState} from "../../../core/reel/ReelState";
import {TombstoneRipSound} from "../../sound/TombstoneRipSound";
import {TombstoneRip} from "../../TombstoneRip";

export class ReelStopSoundController extends ReelStopPresentationController {

    private _spinStates:boolean[];
    private _davidPanningReelStop: number[] = [-0.14, -0.07, -0.01, 0.01, 0.07, 0.14];

    constructor() {
        super('ReelStopSoundController');
    }

    public async start():Promise<any> {
        this._spinStates = TombstoneRip.reels.map(reel => reel.reelState === ReelState.SPIN);
        await super.start();
    }

    protected onReelStopped(data:IReelStateEventData):Promise<void> {
        if(!this.playSpecialLandSound(data.reelId)) {
            const sound = TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.REELS_LANDING[data.reelId]});
            if (sound) {
                sound.player.stereo(this._davidPanningReelStop[data.reelId]);
            }
        }

        this._spinStates[data.reelId] = false;
        // Logger.logDev(`on reel ${data.reelId} stop, reels stop states is ${this._spinStates.toString()}`);
        if(this._spinStates.every(s => !s)) {
            TombstoneRipSound.soundPlayer.stopTrack(TombstoneRipSound.REELS_SPINNING);
            // if(data.reelId === 2) {
            //     // https://github.com/nolimitcity/tombstonerip/issues/401
            //     debugger;
            // }
        }

        return super.onReelStopped(data);
    }

    private playSpecialLandSound(reelId:number):boolean {
        if(reelId === 0) {
            return false;
        }

        if(TombstoneRip.model.parsedGameData.doReelNudge[reelId]) {
            TombstoneRipSound.playNudgeLand();
            return true;
        }

        let name:string;
        if(TombstoneRip.model.reels[reelId].some((symName, symIndex) => {
            if(symName.includes("W") && TombstoneRip.reels[reelId].isDataSymbolInValidArea(symIndex)) {
                name = symName;
                return true;
            }
            return false;
        })) {
            this.playWildLandingSound(name!, reelId);
            return true;
        }

        return false;
    }

    private playWildLandingSound(symName:string, reelId:number):void {
        if(symName === "WRS") {
            TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.WRS_LAND});
            return;
        }

        if(symName === "WXS") {
            TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.WXS_LAND});
        }

        TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.REGULAR_W_LAND[reelId]});
    }
}